import { Component, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationDialogComponent } from '@app/components';
import { SettingsRoleMenuService } from '@app/modules/settings/services';
import { NotifyService } from '@app/services/notify.service';
import { RoleDescriptionDisplayOptions, RoleNameDisplayOptions } from '@app/types/translatables/role-display.options';
import { ShowView } from '@common/views';
import { Account } from '@models/account/account.model';
import { Role } from '@models/account/role.model';

@Component({
    templateUrl: './role-show.template.html',
    styleUrls: ['./role-show.style.scss'],
})
export class RoleShowView extends ShowView {
    @ViewChild('confirmDeleteDialog', { static: true }) confirmDeleteDialog!: ConfirmationDialogComponent;

    isLoading = false;
    isEditRoleDialogOpen = false;
    role: Role;
    accountUpdatePermission = Account.permission.edit;

    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private notify: NotifyService,
        public settingsRoleMenuService: SettingsRoleMenuService
    ) {
        super();
        this.role = this.route.snapshot.data.models.get('role');
    }

    get roleName(): string {
        return RoleNameDisplayOptions[this.role.name] ?? this.role.name;
    }

    get roleDescription(): string {
        return RoleDescriptionDisplayOptions[this.role.description] ?? this.role.description;
    }

    async onSave(): Promise<void> {
        try {
            await this.role.save();
            this.notify.success('settings.role.updateRoleSuccessMessage');
        } catch (error) {
            this.notify.error(error.message || 'settings.role.updateRoleErrorMessage');
        }
    }

    async onDelete(): Promise<void> {
        if (this.role.roleAssignments?.length) {
            return;
        }

        const confirm = await this.confirmDeleteDialog.open();

        if (!confirm) {
            return;
        }

        this.isLoading = true;

        try {
            await this.role.delete();
            this.notify.success('settings.role.deleteRoleSuccessMessage');
            this.router.navigate(['../'], { relativeTo: this.route });
        } catch (error) {
            this.notify.error(error.message);
        }
    }

    onCancel(): void {
        this.role.revert();
    }
}
